import { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { driver } from 'driver.js';

import { ROUTES } from '../../../constants/routes';

import HamburgerSVG from './HamburgerSVG';

const nextActionContent = `<div class="text-base"> Stockup AI Indicator là công cụ hỗ trợ cho nhà đầu tư giao dịch phái sinh. Bằng cách sử dụng công nghệ trí tuệ nhân tạo(AI) và máy học(ML) để phân tích dữ liệu giao dịch hiện tại và quá khứ. Công cụ của Stockup.vn có thể đưa ra những ước đoán xu hướng trong ngày của hợp đồng tương lai. Nhà đầu tư có thể sử dụng công cụ này để tham khảo, có thêm thông tin trước khi quyết định giao dịch.
  <ul class="list-[square] pl-5" style="list-style-type: decimal;">
    <li>
      <span class="inline-block align-middle border border-white bg-black w-[7px] h-5"></span> thể hiện xu hướng giao dịch tiếp theo.
    </li>
    <li>
      <span class="inline-block align-middle border border-white bg-black w-[7px] h-5"></span> ở giữa thể hiện xu hướng Trung Lập.
    </li>
    <li>
      <span class="inline-block align-middle border border-white bg-black w-[7px] h-5"></span> <strong class="text-green-500"> Màu xanh lá</strong> thể hiện xu hướng Long.
    </li>
    <li>
      <span class="inline-block align-middle border border-white bg-black w-[7px] h-5"></span> <strong class="text-red-700"> Màu đỏ</strong> thể hiện xu hướng Short.
    </li>
  </ul>
</div>`;

const tradingViewChart = `
  <div class="text-base">
  Tích hợp công nghệ biều đồ từ TradingView với tất cả các tính năng hiện có, ngoài ra Stockup.vn còn hỗ trợ thêm:
  <ul class="list-decimal pl-5 mt-2 mb-2">
    <li>
      Hiển thị dữ liệu hợp đồng phái sinh theo thời gian thực.
    </li>
    <li>
      Hỗ trợ nhiều khung thời gian khác nhau.
    </li>
    <li>
      Không giới hạn các chỉ báo phân tích kỹ thuật.
    </li>
    <li>
      Dễ dàng so sánh các chỉ số khác (VN-Index, VN30-Index...) theo thời gian thực trên biểu đồ.
    </li>
    <li>
      Lưu lại trạng thái làm việc.
    </li>
  </ul>
  giúp nhà đầu tư có thể dễ dàng theo dõi và phân tích kỹ thuật cho hợp đồng tương lại theo thời gian thực ngay trên ứng dụng Stockup.vn
  </div>`;

const volumePerDay = `<div class="text-base">
  Khối lượng giao dịch của hợp đồng phái sinh từ ngày đầu giao dịch đến thời điểm hiện tại. Nhà đầu tư có thể nắm bắt nhanh chóng thông tin về:
  <ul class="pl-5 mt-2 mb-2">
    <li>
      <span style="background-color: #790384;border-radius: 10px;width: 10px;height: 10px;display: inline-block;">
      </span>
      Tổng khối lượng giao dịch
    </li>
    <li>
      <span style="background-color: #e76bed;border-radius: 10px;width: 10px;height: 10px;display: inline-block;">
      </span>
      Khối lượng hợp đồng mở (IO)
    </li>
  </ul>
</div>`;

const contractGap = `<div class="text-base">
  Giúp nhà đầu tư xác định số điểm dao động của hợp đồng phái sinh theo khung thời gian nhất định.<br />Biểu đồ gồm 3 phần:
  <ul>
    <li>
      <span
      style="background-color: rgb(0, 142, 0);border-radius: 10px;width: 10px;height: 10px;display: inline-block;">
      </span>
      Dao động tăng so với mức giá đóng cửa.
    </li>
    <li>
      <span
      style="background-color: rgb(179, 3, 3);border-radius: 10px;width: 10px;height: 10px;display: inline-block;">
      </span>
      Dao động giảm so với mức giá đóng cửa.
    </li>
    <li>
      <span
      style="background-color: #fff;border-radius: 10px;width: 10px;height: 10px;display: inline-block;">
      </span>
      Dao động từ thấp nhất đến cao nhất trong khung thời gian.
    </li>
  </ul>
</div>`;

const dailyTradingHistory = `<div class="text-base text-justify">
Dữ liệu khớp lệnh của hợp đồng phái sinh theo thời gian thực, được trình bày rõ ràng giúp nhà đầu tư nắm bắt nhanh chóng, rõ ràng tình hình hiện tại của hợp đồng phái sinh.<br />Lịch sử khớp lệnh theo thời gian thực với:
<ul style="margin-left: 0px;">
  <li>
    <span
      className="w-3.5 h-3.5 rounded-full inline-block"
      style="background-color: rgb(188 240 218);border-radius: 10px;width: 10px;height: 10px;display: inline-block;"
    ></span>
    Khớp lệnh mua(L)
  </li>
  <li>
    <span
      className="w-3.5 h-3.5 rounded-full inline-block"
      style="background-color: rgb(253 232 232);border-radius: 10px;width: 10px;height: 10px;display: inline-block;"
    ></span>
    Khớp lệnh bán(S)
  </li>
  <li>
    <span
      className="w-3.5 h-3.5 rounded-full inline-block"
      style="background-color: rgb(112 239 185);border-radius: 10px;width: 10px;height: 10px;display: inline-block;"
    ></span>
    Khớp lệnh mua có khối lượng giao dịch lớn
  </li>
  <li>
    <span
      className="w-3.5 h-3.5 rounded-full inline-block"
      style="background-color: rgb(234 124 124);border-radius: 10px;width: 10px;height: 10px;display: inline-block;"
    ></span>
    Khớp lệnh bán có khối lượng giao dịch lớn
  </li>
</ul>
</div>`;

const volumeChartContent = `<div class="text-base text-justify">
Nhà đầu tư có thể so sánh trực quan giữa khớp lệnh mua và khớp lệnh bán so với tổng khối lượng khớp lệnh tính đến thời điểm hiện tại.
<ul style="margin-left: 0px;">
  <li>
    Tổng khối lượng khớp lệnh
  </li>
  <li>
    <span
      className="w-3.5 h-3.5 rounded-full inline-block bg-red-700"
      style="border-radius: 10px;width: 10px;height: 10px;display: inline-block;background-color: #008e00;"
    ></span>
    Tổng khớp lệnh mua
  </li>
  <li>
    <span
      className="w-3.5 h-3.5 rounded-full inline-block bg-green-500"
      style="border-radius: 10px;width: 10px;height: 10px;display: inline-block;background-color: #b30303;"
    ></span>
    Tổng khớp lệnh bán
  </li>
</ul>
</div>`;

const vn30Content = `<div class="text-base">
Hỗ trợ theo dõi nhanh chóng chỉ số VN30-Index trên cùng 1 màn hình. Nhà đầu tư có thêm thông tin, so sánh chỉ số VN30 và hợp đồng phái sinh trước khi ra quyết định đầu tư.
</div>`;

const headerHeight = document.querySelector('#header')?.offsetHeight || 0;
const driverObj = driver({
  offsetX: 0,
  offsetY: headerHeight,
  showProgress: true,
  showButtons: ['next', 'previous'],
  nextBtnText: 'Tiếp Theo',
  prevBtnText: 'Trước Đó',
  doneBtnText: 'Hoàn Thành',
  progressText: '{{current}}/{{total}}',
  stagePadding: 5,
  steps: [
    {
      element: '#summarySection',
      popover: {
        title: 'Thông tin chung',
        description:
          '<div class="text-base">Thông tin về hợp đồng phái sinh, ngày giao dịch, các mức giá gồm Giá trần, Giá sàn, Giá tham chiếu, Giá mở cửa.</div>',
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '#liveNote',
      popover: {
        title: 'Ghi chú',
        description:
          'Ghi chú lại thông cần thiết, chiến lược giao dịch, những chú ý quan trọng của riêng bạn trong quá trình giao dịch phái sinh VN30.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '#nextActionSection',
      popover: {
        title: 'Stockup AI Indicator',
        description: nextActionContent,
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '#largeTradingSection',
      popover: {
        title: 'Khớp lệnh lớn',
        description:
          '<div class="text-base">Thống kê các giao dịch có khớp lệnh lớn trong ngày. Các giao dịch có khớp lệnh lớn có thể ảnh hưởng đến xu hướng của hợp đồng phái sinh.</div>',
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '#dailyTradingHistoryLiveSection',
      popover: {
        title: 'Lịch sử khớp lệnh',
        description: dailyTradingHistory,
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '#tradeStationSection',
      popover: {
        title: 'Đồ thị kỹ thuật',
        description: tradingViewChart,
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '#vn30IndexSection',
      popover: {
        title: 'Đồ thị kỹ thuật VN30-Index',
        description: vn30Content,
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '#dailyTradingLimitSection',
      popover: {
        title: 'Biên độ dao động',
        description: contractGap,
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '#salesContractQuantitySection',
      popover: {
        title: 'Khớp lệnh theo bước giá',
        description:
          '<div class="text-base">Thống kê tổng khối lượng khớp lệnh mua(<strong class="text-green-500">L</strong>), tổng khối lượng khớp lệnh bán(<strong class="text-red-700">S</strong>) của từng bước giá đến thời điểm hiện tại. Nhà đầu tư có thể thảm khảo thông tin trong thống kê để xác được bước giá phù hợp trước khi quyết định giao dịch.</div>',
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '#volumeChartSection',
      popover: {
        title: 'Khối lượng khớp lệnh',
        description: volumeChartContent,
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '#dailyTradingHistory15MinutesSection',
      popover: {
        title: 'Lịch sử khớp lệnh(15 phút)',
        description:
          '<div class="text-base">Thống kê khớp lệnh của hợp đồng phái sinh trong mỗi 15 phút.</div>',
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '#totalVolumeChartSection',
      popover: {
        title: 'Khối lượng theo ngày',
        description: volumePerDay,
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '#salesContractQuantitySectionFull',
      popover: {
        title: 'Khớp lệnh theo bước giá (Từ ngày GDĐT)',
        description:
          'Thống kê tổng khối lượng khớp lệnh mua(L), tổng khối lượng khớp lệnh bán(S) của từng bước giá từ ngày giao dịch đầu tiên đến thời điểm hiện tại. Nhà đầu tư có thể thảm khảo thông tin trong thống kê để xác được bước giá phù hợp trước khi quyết định giao dịch.',
        side: 'left',
        align: 'start',
      },
    },
  ],
});

const MobileHamburger = ({
  setIsMenuSideBarOpen,
  handleOpenInstructionalVideo,
  tickers,
  accountInformationData,
  saveNotificationOptions,
  isAccountInformationLoading,
}) => {
  const isFuturesInsight = () => {
    const path = window.location.href.split('/');
    const id = path[path.length - 1].replace(/#/g, '');
    return (
      tickers.includes(id) ||
      (id.toLowerCase().indexOf('chung-khoan-phai-sinh') !== -1 &&
        id.toLowerCase().indexOf('dang-ky-chung-khoan-phai-sinh') === -1)
    );
  };

  useEffect(() => {
    if (accountInformationData?.notificationOptions) {
      const parseData = JSON.parse(accountInformationData.notificationOptions);
      if (!parseData?.showTour && isFuturesInsight()) {
        setTimeout(() => {
          driverObj.drive();
          saveNotificationOptions({
            ...parseData,
            showTour: true,
          });
        }, 300);
      }
    }
    if (
      !accountInformationData &&
      isFuturesInsight() &&
      !isAccountInformationLoading
    ) {
      document.location.href = ROUTES.login;
    }
  }, [accountInformationData]);

  const toggleTourOpen = () => {
    driverObj.drive();
  };

  disableBody = (target) => disableBodyScroll(target);
  enableBody = (target) => enableBodyScroll(target);

  return (
    <div className="w-1/3 sm:w-1/4 flex items-center lg:w-2/5 text-black dark:text-white">
      <button
        className="p-1 text-xs mr-1 md:mr-4 -ml-1 rounded-md focus:outline-none focus:shadow-outline-purple"
        onClick={() => setIsMenuSideBarOpen(true)}
      >
        <HamburgerSVG />
      </button>
      {document.location.pathname.indexOf('/stockup-ai') === -1 &&
      document.location.pathname !== '/' ? (
        <>
          {isFuturesInsight() ? (
            <>
              <a
                href="#"
                onClick={toggleTourOpen}
                className="text-sm hidden md:block hover:underline hover:text-primary-main transition ease-in-out duration-200"
              >
                Hướng Dẫn Sử Dụng
              </a>
              <Tooltip title="Hướng Dẫn Sử Dụng">
                <span className="block md:hidden">
                  <IconButton onClick={toggleTourOpen}>
                    <HelpOutlineIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </>
          ) : (
            <>
              <a
                href="#"
                onClick={handleOpenInstructionalVideo}
                className="text-sm hidden md:block hover:underline hover:text-primary-main transition ease-in-out duration-200"
              >
                Cách Tìm Cổ Phiếu
              </a>
              <Tooltip title="Cách Tìm Cổ Phiếu">
                <span className="block md:hidden">
                  <IconButton onClick={handleOpenInstructionalVideo}>
                    <HelpOutlineIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </>
          )}
        </>
      ) : null}
    </div>
  );
};

export default MobileHamburger;
